// import "./App.css";
import TopSocial from "./components/TopSocial";
import Navbar from "./components/Navbar";
import BigImage from "./components/BigImage";
import About from "./components/About";
import Projects from "./components/Projects";
import Services from "./components/Services";
import Tech from "./components/Tech";
import News from "./components/News";
import Team from "./components/Team";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Map from "./components/Map";


import { Routes, Route } from "react-router-dom";
import HomeNav from "./components/menu/Home";
import AboutNav from "./components/menu/AboutUs";
import ProjectsNav from "./components/menu/Projects";
import ServicesNav from "./components/menu/Services";
import VacantionsNav from "./components/menu/Vacantions";
import NewsNav from "./components/menu/News";
import ContactNav from "./components/menu/Contact";

function App() {
  return (
    <div>
      <TopSocial />
      <Navbar />
      <BigImage />
      <About />
      <Projects />
      <Services />
      <Tech />
      <News />
      <Team />
      <Contact />
      <Map />
      <Footer />

      <Routes>
        <Route path="/" element={<HomeNav />}>
          Əsas səhifə
        </Route>
        <Route path="/haqqimizda" element={<AboutNav />}>
          Haqqımızda
        </Route>
        <Route path="/layiheler" element={<ProjectsNav />}>
          Layihələr
        </Route>
        <Route path="/xidmetler" element={<ServicesNav />}>
          Xidmətlər
        </Route>
        <Route path="/vakansiyalar" element={<VacantionsNav />}>
          Vakansiyalar
        </Route>
        <Route path="/xeberler" element={<NewsNav />}>
          Xəbərlər
        </Route>
        <Route path="/elaqe" element={<ContactNav />}>
          Əlaqə
        </Route>
      </Routes>
    </div>
  );
}

export default App;
